/* 20 Oct error sweep: shared lift helper (also defined in surfpaints-b2b.js). */
var spLiftWant = window.spLiftWant || (window.spLiftWant = function (el) { var a = parseFloat(el._spbLift) || 0, b = parseFloat(el._splpLift) || 0, m = Math.max(a, b); return m ? m + 'px' : null; });
/* Surfpaints landing page: gallery, variant sync across all add-to-cart forms, sticky bar.
   Add to cart itself is handled by Dawn's <product-form> (assets/product-form.js). */
(function () {
  if (window.SurfpaintsLP) return;
  var LP = (window.SurfpaintsLP = {});

  /* ---------- Gallery (scroll-snap track + thumbs + dots) ---------- */
  if (!customElements.get('splp-gallery')) {
    customElements.define('splp-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.thumbs.forEach((b) => b.addEventListener('click', () => this.go(b.dataset.mediaId)));
        if (this.track && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((e) => { if (e.isIntersecting && e.intersectionRatio > 0.6) this.mark(e.target.dataset.mediaId); });
          }, { root: this.track, threshold: [0.6] });
          this.slides.forEach((s) => this.io.observe(s));
        }
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
      go(id) {
        var s = this.slides.find((x) => x.dataset.mediaId === String(id));
        if (!s || !this.track) return;
        this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.mark(id);
      }
      mark(id) {
        this.thumbs.forEach((b) => b.setAttribute('aria-current', String(b.dataset.mediaId === String(id))));
        this.dots.forEach((d) => d.classList.toggle('is-active', d.dataset.mediaId === String(id)));
        /* Pause normal (controls) videos when their slide is left; silent loops manage themselves (splp-video). */
        this.slides.forEach((s) => { if (s.dataset.mediaId !== String(id)) s.querySelectorAll('video').forEach((v) => { if (!v.closest('[data-splp-loop]')) v.pause(); }); });
      }
    });
  }

  /* ---------- Variant picker (hero) -> broadcast to every LP form ---------- */
  if (!customElements.get('splp-variant-picker')) {
    customElements.define('splp-variant-picker', class extends HTMLElement {
      connectedCallback() {
        var data = this.querySelector('script[type="application/json"]');
        this.variants = data ? JSON.parse(data.textContent) : [];
        this.selects = Array.from(this.querySelectorAll('select[data-option]'));
        this.selects.forEach((s) => s.addEventListener('change', () => {
          var vals = this.selects.map((x) => x.value);
          var v = this.variants.find((x) => x.options.every((o, i) => o === vals[i])) || null;
          if (v) v.main = true;
          LP.applyVariant(v);
          if (v && this.dataset.url) history.replaceState({}, '', this.dataset.url + '?variant=' + v.id);
        }));
      }
    });
  }

  LP.labelFor = function (btn, v) {
    var lbl = btn.querySelector('[data-splp-atc-label]');
    if (!lbl) return;
    if (!v) { lbl.textContent = btn.dataset.unavailable || 'Unavailable'; return; }
    if (!v.available) { lbl.textContent = btn.dataset.soldout || 'Sold out'; return; }
    lbl.innerHTML = '';
    lbl.append(document.createTextNode(btn.dataset.label || 'Add to cart'));
    if (btn.dataset.showPrice === 'true') {
      var sep = document.createElement('span'); sep.className = 'sep'; sep.textContent = ' · ';
      lbl.append(sep, document.createTextNode(v.price_plain));
    }
  };

  /* Elements inside [data-splp-lock] (e.g. the "Add all 35 colours" button) always follow this page's own product,
     never the bundle / 8-pack picked in the hero offer picker. */
  var all = function (sel, v) {
    return Array.prototype.filter.call(document.querySelectorAll(sel), function (el) { return !v || v.main || !el.closest('[data-splp-lock]'); });
  };
  LP.applyVariant = function (v) {
    var available = !!(v && v.available);
    if (v && v.main) LP.mainVariant = v;
    all('[data-splp-variant-input]', v).forEach(function (i) { i.value = v ? v.id : ''; i.disabled = !available; });
    all('[data-splp-atc]', v).forEach(function (b) { b.disabled = !available; b.removeAttribute('aria-disabled'); LP.labelFor(b, v); });
    if (!v) return;
    var isMain = v.main !== false;
    document.querySelectorAll('[data-splp-main-only]').forEach(function (el) { el.hidden = !isMain; });
    document.querySelectorAll('[data-splp-selected]').forEach(function (el) { el.hidden = isMain; });
    document.querySelectorAll('[data-splp-title]').forEach(function (el) {
      if (el.dataset.orig === undefined) el.dataset.orig = el.textContent;
      el.textContent = isMain ? el.dataset.orig : (v.title || '');
    });
    document.querySelectorAll('[data-splp-thumb] img').forEach(function (img) {
      if (img.dataset.origSrc === undefined) { img.dataset.origSrc = img.getAttribute('src') || ''; img.dataset.origSrcset = img.getAttribute('srcset') || ''; }
      if (isMain || !v.image) { img.setAttribute('src', img.dataset.origSrc); if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset); }
      else { img.removeAttribute('srcset'); img.setAttribute('src', v.image); }
    });
    if (isMain) document.querySelectorAll('[data-splp-main-price]').forEach(function (el) { el.innerHTML = v.available ? v.price : el.innerHTML; });
    all('[data-splp-price]', v).forEach(function (el) { el.innerHTML = v.price; });
    all('[data-splp-compare]', v).forEach(function (el) { el.hidden = !v.compare; el.innerHTML = v.compare || ''; });
    all('[data-splp-saving]', v).forEach(function (el) {
      var t = el.dataset.template || '';
      el.hidden = !v.saving || !t;
      el.textContent = v.saving ? t.replace('[amount]', v.saving).replace('[percent]', v.saving_pct + '%') : '';
    });
    all('[data-splp-instalment]', v).forEach(function (el) {
      var t = el.dataset.template || '';
      var ok = v.price_cents >= Number(el.dataset.min || 0) && v.price_cents <= Number(el.dataset.max || 1e12);
      el.hidden = !ok;
      if (ok) el.textContent = t.replace('[amount]', v.instalment);
    });
    if (v.media) document.querySelectorAll('splp-gallery').forEach(function (g) { g.go(v.media); });
    document.dispatchEvent(new CustomEvent('splp:variant', { detail: v }));
  };

  /* ---------- Offer picker (bundle / this product / 8-pack) ---------- */
  if (!customElements.get('splp-offer-picker')) {
    customElements.define('splp-offer-picker', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.data = {};
        this.querySelectorAll('input[type=radio]').forEach(function (r) {
          var js = r.closest('label') && r.closest('label').querySelector('[data-offer-json]');
          if (js) { try { self.data[r.value] = JSON.parse(js.textContent); } catch (e) {} }
        });
        var sj = this.querySelector('[data-small-json]');
        try { this.small = sj ? JSON.parse(sj.textContent) : []; } catch (e) { this.small = []; }
        this.select = this.querySelector('[data-small-select]');
        this.radios = Array.from(this.querySelectorAll('input[type=radio]'));
        this.radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) self.apply(r.value); }); });
        if (this.select) {
          this.select.addEventListener('change', function () {
            var r = self.radios.find(function (x) { return x.value === 'small'; });
            if (r && !r.checked) r.checked = true;
            self.apply('small');
          });
          /* Clicking the dropdown also picks the 8-pack option */
          this.select.addEventListener('focus', function () {
            var r = self.radios.find(function (x) { return x.value === 'small'; });
            if (r && !r.checked) { r.checked = true; self.apply('small'); }
          });
        }
        document.addEventListener('splp:variant', function (e) {
          /* Keep the main option in step with the product's own variant picker */
          if (e.detail && e.detail.main && !e.detail.key) self.data.main = Object.assign({}, e.detail, { title: (self.data.main || {}).title, key: 'main' });
        });
        var checked = this.radios.find(function (x) { return x.checked; });
        if (checked && checked.value !== 'main') this.apply(checked.value);
      }
      apply(key) {
        var v = key === 'small' ? this.small[Number(this.select ? this.select.value : 0)] : this.data[key];
        if (key === 'main' && LP.mainVariant) v = Object.assign({}, LP.mainVariant, { title: (this.data.main || {}).title, key: 'main' });
        this.classList.toggle('is-small', key === 'small');
        if (v) LP.applyVariant(v);
      }
    });
  }

  /* ---------- Silent looping videos (lazy, pause off-screen, reduced-motion aware) ---------- */
  if (!customElements.get('splp-video')) {
    customElements.define('splp-video', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.video = this.querySelector('video');
        this.btn = this.querySelector('[data-toggle]');
        if (!this.video) return;
        this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.userPaused = this.reduce;
        this.video.muted = true;
        if (this.btn) {
          this.btn.hidden = false;
          this.sync();
          this.btn.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            self.load();
            if (self.video.paused) { self.userPaused = false; self.play(); } else { self.userPaused = true; self.video.pause(); }
          });
        }
        this.video.addEventListener('play', function () { self.sync(); });
        this.video.addEventListener('pause', function () { self.sync(); });
        if (!('IntersectionObserver' in window)) { this.load(); if (!this.userPaused) this.play(); return; }
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            self.visible = e.isIntersecting;
            if (e.isIntersecting) { if (!self.userPaused) { self.load(); self.play(); } }
            else if (!self.video.paused) self.video.pause();
          });
        }, { rootMargin: '200px 0px', threshold: 0.01 });
        this.io.observe(this);
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
      load() {
        if (this.loaded || !this.video.dataset.src) return;
        this.loaded = true;
        this.video.src = this.video.dataset.src;
        this.video.removeAttribute('data-src');
        this.video.preload = 'auto';
      }
      play() {
        var p = this.video.play();
        if (p && p.catch) p.catch(function () {});
      }
      sync() {
        if (!this.btn) return;
        var paused = this.video.paused;
        this.btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        this.classList.toggle('is-paused', paused);
      }
    });
  }

  /* ---------- Project tabs (WAI-ARIA tabs, no library) ---------- */
  if (!customElements.get('splp-tabs')) {
    customElements.define('splp-tabs', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role=tab]'));
        this.tabs.forEach(function (t, i) {
          t.addEventListener('click', function () { self.select(i); });
          t.addEventListener('keydown', function (e) {
            var k = e.key, n = self.tabs.length, j = -1;
            if (k === 'ArrowRight') j = (i + 1) % n; else if (k === 'ArrowLeft') j = (i - 1 + n) % n; else if (k === 'Home') j = 0; else if (k === 'End') j = n - 1;
            if (j > -1) { e.preventDefault(); self.select(j); self.tabs[j].focus(); }
          });
        });
      }
      select(i) {
        this.tabs.forEach(function (t, j) {
          var on = i === j, p = document.getElementById(t.getAttribute('aria-controls'));
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (p) p.hidden = !on;
        });
        var t = this.tabs[i];
        if (t && t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
      }
    });
  }

  /* ---------- Sticky add-to-cart ---------- */
  if (!customElements.get('splp-sticky')) {
    customElements.define('splp-sticky', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.splp-sticky');
        this.btn = this.querySelector('[data-splp-atc]');
        var target = document.querySelector(this.dataset.target || '[data-splp-hero-atc]');
        /* CRO v2: on mobile, optionally show the bar from the first scroll instead of waiting for the hero button to leave view. */
        var firstScroll = this.dataset.mobileFirstScroll === 'true' && window.matchMedia('(max-width: 749px)').matches;
        if (firstScroll) target = null;
        var footer = document.querySelector('footer, .footer');
        var pastTarget = false, footerVisible = false, self = this;
        var sync = function () {
          var show = pastTarget && !footerVisible;
          self.bar.classList.toggle('is-visible', show);
          self.bar.setAttribute('aria-hidden', String(!show));
          self.bar.inert = !show;
          document.body.classList.toggle('splp-sticky-on', show && getComputedStyle(self.bar).display !== 'none');
          document.documentElement.style.setProperty('--splp-sticky-h', self.bar.offsetHeight + 'px');
          self.lift(document.body.classList.contains('splp-sticky-on'));
          self.avoid();
        };
        if (!('IntersectionObserver' in window)) return;
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.target === footer) footerVisible = e.isIntersecting;
            else pastTarget = !e.isIntersecting && e.boundingClientRect.top < 0;
          });
          sync();
        });
        if (target) this.io.observe(target);
        else {
          var y = firstScroll ? Number(this.dataset.mobileOffset || 40) : Number(this.dataset.offset || 600);
          var onScroll = function () { pastTarget = window.scrollY > y; sync(); };
          window.addEventListener('scroll', onScroll, { passive: true });
          onScroll();
        }
        if (footer && this.dataset.hideAtFooter === 'true') this.io.observe(footer);
        window.addEventListener('resize', sync, { passive: true });
        /* Belt and braces: re-check the hero button position on scroll (IntersectionObserver can miss very fast jumps, e.g. anchor links). */
        var ticking = false;
        window.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            if (target) {
              var past = target.getBoundingClientRect().bottom < 0;
              if (past !== pastTarget) { pastTarget = past; sync(); return; }
            }
            if (document.body.classList.contains('splp-sticky-on')) self.lift(true);
            self.avoid();
          });
        }, { passive: true });
        [800, 2500, 6000].forEach(function (t) { setTimeout(function () { self.avoid(); }, t); });
      }
      lift(on) {
        /* Floating widgets (chat bubbles) often set bottom inline with !important, which CSS cannot override. */
        var sel = (this.dataset.lift || '').trim();
        if (!sel) return;
        var els;
        try { els = document.querySelectorAll(sel); } catch (e) { return; }
        var h = this.bar.offsetHeight + Number(this.dataset.liftGap || 12);
        els.forEach(function (el) {
          if (on) {
            if (el.dataset.splpBottom === undefined) {
              el.dataset.splpBottom = el.dataset.spbBottom !== undefined ? el.dataset.spbBottom : el.style.getPropertyValue('bottom') + '|' + el.style.getPropertyPriority('bottom');
            }
            el._splpLift = h + 'px';
            el.style.setProperty('transition', 'bottom .3s ease');
            var w0 = spLiftWant(el);
            if (el.style.getPropertyValue('bottom') !== w0) el.style.setProperty('bottom', w0, 'important');
            if (!el._splpMO && 'MutationObserver' in window) {
              /* The widget re-writes its own position on scroll; keep it above the bar while the bar shows.
                 20 Oct error sweep: aim for the shared (larger) lift so this never fights surfpaints-b2b.js's observer on the same widget (that loop froze the bulk page on mobile). */
              el._splpMO = new MutationObserver(function () {
                var w = spLiftWant(el);
                if (el._splpLift && w && el.style.getPropertyValue('bottom') !== w) el.style.setProperty('bottom', w, 'important');
              });
              el._splpMO.observe(el, { attributes: true, attributeFilter: ['style'] });
            }
          } else if (el.dataset.splpBottom !== undefined) {
            el._splpLift = null;
            var o = el.dataset.splpBottom.split('|');
            delete el.dataset.splpBottom;
            var w1 = spLiftWant(el);
            if (w1) { if (el.style.getPropertyValue('bottom') !== w1) el.style.setProperty('bottom', w1, 'important'); }
            else el.style.setProperty('bottom', o[0], o[1]);
          }
        });
      }
      avoid() {
        /* Hide the collapsed chat bubble while it would sit on top of a buy button or the offer picker (e.g. the mobile hero at first load). */
        var sel = (this.dataset.lift || '').trim();
        if (!sel) return;
        var els;
        try { els = Array.from(document.querySelectorAll(sel)); } catch (e) { return; }
        var zones = Array.from(document.querySelectorAll('splp-offer-picker, [data-splp-atc]')).filter(function (z) { return !z.closest('.splp-sticky'); });
        var hide = els.some(function (el) {
          var r = el.getBoundingClientRect();
          if (!r.width || r.width > 90 || r.height > 90) return false; /* open chat window: never hide */
          return zones.some(function (z) {
            var b = z.getBoundingClientRect();
            return b.width && b.right > r.left - 6 && b.left < r.right + 6 && b.bottom > r.top - 6 && b.top < r.bottom + 6;
          });
        });
        document.body.classList.toggle('splp-chat-hide', hide);
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); document.body.classList.remove('splp-sticky-on'); document.body.classList.remove('splp-chat-hide'); this.lift(false); }
    });
  }
})();

/* Theme editor: show a project tab when its block is selected */
document.addEventListener('shopify:block:select', function (e) {
  var t = document.getElementById('splp-tab-' + (e.detail && e.detail.blockId));
  if (!t) return;
  var host = t.closest('splp-tabs');
  if (host && host.select) host.select(host.tabs.indexOf(t));
});

/* ---------- Order bump: tick to add an add-on together with the main product (one /cart/add.js call with an items array) ---------- */
(function () {
  if (customElements.get('splp-bump')) return;
  function syncForms(bump) {
    var on = bump.box.checked;
    bump.classList.toggle('is-on', on);
    document.querySelectorAll('[data-splp-atc]').forEach(function (btn) {
      if (btn.closest('[data-splp-lock]') || btn.dataset.showPrice !== 'true') return;
      var lab = btn.querySelector('[data-splp-atc-label]');
      if (!lab || btn.disabled) return;
      lab.innerHTML = '';
      lab.appendChild(document.createTextNode(btn.dataset.label || 'Add to cart'));
      var sep = document.createElement('span'); sep.className = 'sep'; sep.textContent = ' · ';
      lab.appendChild(sep);
      lab.appendChild(document.createTextNode(on ? bump.dataset.totalOn : bump.dataset.totalOff));
    });
  }
  customElements.define('splp-bump', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.box = this.querySelector('[data-splp-bump-box]');
      if (!this.box) return;
      window.splpBump = this;
      this.box.addEventListener('change', function () { syncForms(self); });
      if (this.box.checked) syncForms(this);
    }
  });
  function openCart() {
    try {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return true; }
    } catch (e) {}
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        if (typeof drawer.renderContents === 'function') { drawer.renderContents({ sections: s }); return true; }
        drawer.open(); return true;
      });
    }
    return false;
  }
  function onBuy(e) {
    var b = window.splpBump;
    var t = e.target;
    var form = e.type === 'submit' ? t : (t && t.closest && t.closest('button[type=submit], input[type=submit]') ? t.closest('form') : null);
    if (!b || !b.box || !b.box.checked || !form || !form.closest || !form.closest('product-form.splp-form')) return;
    if (form.closest('[data-splp-lock]')) return;
    var idInput = form.querySelector('[name=id]');
    if (!idInput || !idInput.value) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = form.querySelector('[type=submit]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    var qtyInput = form.querySelector('[name=quantity]');
    var items = [{ id: Number(idInput.value), quantity: Number(qtyInput && qtyInput.value) || 1 }, { id: Number(b.dataset.variant), quantity: 1 }];
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to cart');
        document.dispatchEvent(new CustomEvent('splp:bump-added', { detail: res.j }));
        return Promise.resolve(openCart()).then(function (opened) { if (!opened) window.location.href = root + 'cart'; });
      })
      .catch(function (err) {
        var wrap = form.closest('product-form');
        var msg = wrap && wrap.querySelector('.product-form__error-message');
        if (msg) { msg.textContent = err.message; msg.closest('[role=alert]').hidden = false; } else { alert(err.message); }
      })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } });
  }
  /* Capture on window (before cart apps such as UpCart, which hijack the button click) */
  window.addEventListener('click', onBuy, true);
  window.addEventListener('submit', onBuy, true);
})();

/* ---------- Choose-your-set dropdowns ---------- */
document.addEventListener('change', function (e) {
  var sel = e.target;
  if (!sel.matches || !sel.matches('[data-splp-opt-select]')) return;
  var card = sel.closest('[data-splp-opt]');
  var o = sel.options[sel.selectedIndex];
  var input = card.querySelector('[name=id]');
  if (input) { input.value = o.value; input.disabled = false; }
  var pr = card.querySelector('[data-splp-opt-price]'); if (pr) pr.textContent = o.dataset.price || '';
  var per = card.querySelector('[data-splp-opt-per]'); if (per) per.textContent = o.dataset.per || '';
});
